import { UserManager, WebStorageStateStore } from 'oidc-client';
import store from '@/store/index.js';
import Cookies from 'js-cookie';
import api from '@/helpers/api.js';

const settings = {
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  authority: process.env.VUE_APP_STS_DOMAIN,
  scope: process.env.VUE_APP_SCOPE,
  client_id: process.env.VUE_APP_CLIENT_ID,
  redirect_uri: process.env.VUE_APP_REDIRECT_URI,
  automaticSilentRenew: true,
  validateSubOnSilentRenew: true,
  silent_redirect_uri: process.env.VUE_APP_SILENT_REDIRECT_URI,
  silentRequestTimeout: 10000,
  post_logout_redirect_uri: process.env.VUE_APP_POST_LOGOUT_REDIRECT_URI,
  response_type: 'code',
  popupWindowFeatures:
    'location=no,toolbar=no,width=450,height=650,left=250,top=100',
  filterProtocolClaims: false,
  loadUserInfo: true
};

export function useUserStore() {
  return new AuthService();
}

export default class AuthService {
  async getManager() {
    let manager = store.state.userManager;

    if (!manager) {
      const currentUri = encodeURI(location.href).replace('#', '__');
      const serverSettings = await api.getAnonymous(
        `/auth/get-config?url=${currentUri}`
      );

      if (serverSettings) {
        settings.authority = serverSettings.authority;
        settings.client_id = serverSettings.clientId;
        settings.redirect_uri = serverSettings.redirectUri;
        settings.silent_redirect_uri = serverSettings.silentRedirectUri;
        settings.post_logout_redirect_uri = serverSettings.postLogoutUri;
      }

      manager = new UserManager(settings);
      store.state.userManager = manager;
    }

    return manager;
  }

  async getUser() {
    const manager = await this.getManager();
    const user = await manager.getUser();
    return user;
  }

  async login() {
    Cookies.set(
      'returnUrl',
      window.location.href.substring(window.location.href.indexOf('#') + 1)
    );

    const manager = await this.getManager();
    return await manager.signinRedirect();
  }

  async loginPopup() {
    const manager = await this.getManager();
    var user = await manager.signinPopup();

    if (user) {
      return user;
    }

    return null;
  }

  async logout() {
    const manager = await this.getManager();
    return await manager.signoutRedirect();
  }

  async logoutPopup() {
    const manager = await this.getManager();
    return await manager.signoutPopupCallback();
  }

  async getAccessToken() {
    const manager = await this.getManager();
    var user = await manager.getUser();

    if (user != null) {
      return user.access_token;
    }

    return null;
  }

  async signinRedirectCallback() {
    try {
      const manager = await this.getManager();
      var user = await manager.signinRedirectCallback();
      if (user) {
        user.returnUrl = Cookies.get('returnUrl');
        Cookies.remove('returnUrl');
        return user;
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  async signinPopupCallback() {
    try {
      const manager = await this.getManager();
      var user = await manager.signinPopupCallback();

      if (user) {
        return user;
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  async signinSilentCallback() {
    try {
      const manager = await this.getManager();
      var user = await manager.signinSilentCallback();

      if (user) {
        return user;
      }

      return null;
    } catch (error) {
      return null;
    }
  }
}
